'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.spid = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _types = require('./types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultState = function defaultState() {
    return {
        initialized: false,
        clientAgreementAccepted: false,
        defaultAgreementAccepted: false,
        displayName: null,
        error: null,
        familyName: null,
        givenName: null,
        loggedIn: false,
        photo: null,
        login: null,
        logout: null,
        accountUrl: null,
        signupUrl: null,
        userId: null,
        visitorId: null,
        visitorUid: null,
        productId: null,
        hasProduct: false
    };
};

/* eslint-disable import/prefer-default-export */
var spid = exports.spid = function spid() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState();
    var action = arguments[1];

    if (action.type === _types.SPID_INIT && action.payload.productId) {
        return (0, _extends3.default)({}, state, {
            productId: action.payload.productId
        });
    }

    if (action.type === _types.SPID_INIT_COMPLETE) {
        return (0, _extends3.default)({}, state, action.payload, {
            initialized: true
        });
    }

    if (action.type === _types.SPID_EVENT_LOGIN) {
        return (0, _extends3.default)({}, state, {
            loggedIn: true,
            userId: action.payload.userId
        });
    }

    if (action.type === _types.SPID_EVENT_LOGOUT || action.type === _types.SPID_EVENT_NOTLOGGEDIN) {
        return (0, _extends3.default)({}, state, {
            clientAgreementAccepted: false,
            defaultAgreementAccepted: false,
            displayName: null,
            familyName: null,
            givenName: null,
            loggedIn: false,
            photo: null,
            userId: null,
            hasProduct: false
        });
    }

    if (action.type === _types.SPID_EVENT_VISITOR) {
        return (0, _extends3.default)({}, state, {
            visitorId: action.payload.user_id || null,
            visitorUid: action.payload.uid || null
        });
    }

    if (action.type === _types.SPID_EVENT_SESSION_CHANGE) {
        var _action$payload = action.payload,
            _action$payload$clien = _action$payload.clientAgreementAccepted,
            clientAgreementAccepted = _action$payload$clien === undefined ? null : _action$payload$clien,
            _action$payload$defau = _action$payload.defaultAgreementAccepted,
            defaultAgreementAccepted = _action$payload$defau === undefined ? null : _action$payload$defau,
            _action$payload$displ = _action$payload.displayName,
            displayName = _action$payload$displ === undefined ? null : _action$payload$displ,
            _action$payload$famil = _action$payload.familyName,
            familyName = _action$payload$famil === undefined ? null : _action$payload$famil,
            _action$payload$given = _action$payload.givenName,
            givenName = _action$payload$given === undefined ? null : _action$payload$given,
            _action$payload$photo = _action$payload.photo,
            photo = _action$payload$photo === undefined ? null : _action$payload$photo,
            _action$payload$sig = _action$payload.sig,
            sig = _action$payload$sig === undefined ? null : _action$payload$sig;


        return (0, _extends3.default)({}, state, {
            clientAgreementAccepted: clientAgreementAccepted,
            defaultAgreementAccepted: defaultAgreementAccepted,
            displayName: displayName,
            familyName: familyName,
            givenName: givenName,
            photo: photo,
            sig: sig
        });
    }

    if (action.type === _types.SPID_HAS_SESSION_ERROR) {
        return (0, _extends3.default)({}, state, {
            error: (0, _extends3.default)({}, state.error, {
                session: action.payload
            })
        });
    }

    if (action.type === _types.SPID_EVENT_SESSION_ERROR) {
        return (0, _extends3.default)({}, state, {
            error: (0, _extends3.default)({}, state.error, {
                event: action.payload
            })
        });
    }

    if (action.type === _types.SPID_HAS_PRODUCT_ERROR) {
        return (0, _extends3.default)({}, state, {
            hasProduct: false,
            error: (0, _extends3.default)({}, state.error, {
                product: action.payload
            })
        });
    }

    if (action.type === _types.SPID_HAS_PRODUCT_COMPLETE) {
        return (0, _extends3.default)({}, state, {
            hasProduct: action.payload.result
        });
    }

    if (action.type === _types.SPID_GENERATE_URLS) {
        return (0, _extends3.default)({}, state, action.payload);
    }

    return state;
};
/* eslint-enable import/prefer-default-export */
//# sourceMappingURL=reducers.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/redux-spid/lib/cjs/reducers.js
 ** module id = 549
 ** module chunks = 1
 **/